/// <reference path="commondataservicebase.ts" />
/// <reference path="common.interface.ts" />
/// <reference path="../models/meevo.model.custom.ts" />
/// <reference path="../models/meevo.dtos.d.ts" />
/// <reference path="../modal/modal.interface.ts" />
/// <reference path="../common/identity.service.ts" />
/// <reference path="../common/common.interface.ts" />
module Meevo.Components.CommonClasses {
    import StorageFile = Meevo.Model.IStorageFile;

    /**
  * Common context base class.  Supplies all of the constructs for the Update & manangement of sections.
  * The primary section Update is managed by this form.  Non-Primary sections Update is managed internally by their
  * custom implementation.
  */
    export abstract class CommonContextBase implements Meevo.Components.CommonClasses.ICommonContext {
        sections: Meevo.Components.CommonClasses.ICommonSection[] = [];
        selectedSection: Meevo.Components.CommonClasses.ICommonSection;
        headerContent = "";
        holidayTypeHolidays: any;
        preventUsageTracking?: boolean;

        protected appSettings: Meevo.Components.Common.IAppSettings;
        protected dataService: Meevo.Components.CommonClasses.ICommonDataService;
        protected modalService: Meevo.Components.Modal.IModalService;
        protected identityService: Meevo.Components.Common.IIdentityService;
        protected loggingService: Meevo.Components.Logging.ILoggingService;
        protected trackingService: Meevo.Components.Tracking.ITrackingService;
        protected auditNoun: Meevo.Model.NounEnum;
        protected baseEndpoint: string;
        protected baseEndpoint2: string;
        protected sectionTemplatePath: string;
        protected loadingInProgress: boolean;
        protected mode: Meevo.Model.MaintenanceFormState;
        protected isLoaded: boolean;
        protected securityKeys = Meevo.Components.Common.SecurityKeys;
        protected securityParts = Meevo.Components.Common.SecurityParts;
        protected securityChecker: Meevo.Components.Common.ISecurityService;
        protected todayDate: Date;

        protected addSecurityKey: string;
        protected editSecurityKey: string;
        protected copySecurityKey: string;
        protected deleteSecurityKey: string;
        protected isInCallCenterLocation: boolean;
       
        public closeCallback: Meevo.Components.BaseClasses.CloseContextCallback;
        /**
         * Instantiantes the service with the necessary dependencies.
         * @param appSettings
         * @param dataService
         * @param modalService
         * @param identityService
         * @param loggingService,
         * @param securityChecker
         * @param trackingService
         * @returns {}
         */
        constructor(
            appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService = null
        ) {

            this.securityChecker = securityChecker;
            this.appSettings = appSettings;
            this.dataService = dataService;
            this.modalService = modalService;
            this.identityService = identityService;
            this.loggingService = loggingService;
            this.trackingService = trackingService;
            this.setMode(Model.MaintenanceFormState.Readonly);
            this.isInCallCenterLocation = this.identityService.inCallCenterMode() && !this.identityService.isEmulating;
        }



        /**
        * Responsible for initializing all sections belonging to the maintenance service.
        * @return {}
        */
        protected abstract initializeSections(): void;

        /**
        * Responsible for initializing the header of the maintenance service.
        * This gets called only if isPrimarySection = true.  It supplies the model loaded
        * for the section to the method so that dynamic content can populate the header.
        * @return {}
        */
        protected abstract initializeHeader(model: any): void;

        /**
         * Activates the Common maintenance form and selects the first section.
         * It will also call the dataserve to load the item.
         * @returns {}
         */
        activate() {

            if (!this.sections || this.sections.length === 0)
                this.loggingService.error("At least 1 section definition is required.");

            this.loggingService.trace(`Opening Common form`);

            this.initializeForEdit();

            let defaultIndex = _.findIndex(this.sections, s => s.sectionSecurityKey ? this.securityChecker.hasSecurity(s.sectionSecurityKey) : true);

            if (Model.Guard.isSomething(this.sections[defaultIndex]))
                this.selectSection(this.sections[defaultIndex]);

        }

        /**
        *  Prepares the mainteance form for editing a selected item.
        *  @returns {}
        */
        initializeForEdit() {
            this.setMode(Meevo.Model.MaintenanceFormState.Readonly);
        }

        setMode(newMode: Meevo.Model.MaintenanceFormState) {
            //arod: not my design;
            this.mode = newMode;
            if (Model.Guard.isSomething(this.selectedSection))
                this.selectedSection.mode = newMode;

        }

        /**
         * Selects the specified section of the maintance form and activates it.
         * @param {IDataMaintenanceSection} item
         * @returns {}
         */
        selectSection(section: Meevo.Components.CommonClasses.ICommonSection): void {

            if (section == this.selectedSection)
                return;
            if (this.selectedSection && this.navigationBlocked) {
                if (this.selectedSection !== section) {
                    this.modalService.alert("MESSAGE_PENDING_CHANGES");
                }
                else {
                    this.modalService.alert("MESSAGE_PENDING_TAB_CHANGES");
                }
                this.selectSection(this.selectedSection);
            } else {
                this.selectedSection = section;

                if (!this.selectedSection.isLoaded && !this.selectedSection.handlesOwnCrud) {
                    this.loadingInProgress = true;
                    /**
                     *  When Creating Context Let's Use 'this.selectedSection.baseEndpoint' If Provided
                     *  This Will Allow To Hit A Different sectionEndPoint besides the baseEndpoint
                     */
                    const sectionEndPoint = this.selectedSection.baseEndpoint || this.baseEndpoint;
                    this.dataService.getSection(sectionEndPoint, this.selectedSection.sectionEndpoint).then((data: any) => {
                        this.selectedSection.model = data;
                        this.selectedSection.activate();
                        this.sectionModelRetrieved();

                        if (this.selectedSection.isPrimarySection) {
                            this.initializeHeader(data);
                        }

                    }).catch(ex => {
                        this.sectionModelRetrievalFailure(ex);
                    })
                    .finally(() => { this.loadingInProgress = false });
                }

                this.selectedSection.selected();

                this.usageTrackingLog(Meevo.Model.VerbEnum.Viewed, null);
            }
        }

        /**
         * search for the storage file URL if model implements FileMetadata
         */
        searchFile(filedata: StorageFile, searchKey: string, defaultUrl: string): string {
            let filedetails = undefined;
            let fileUrl = defaultUrl;
            if (filedata)
            { filedetails = filedata; }
            else
            { filedetails = <Model.IStorageFile>this.selectedSection.model; }

            if (filedetails
                && filedetails.meevoFile
                && filedetails.meevoFile.files
                && filedetails.meevoFile.files.length > 0) {

                filedetails.meevoFile.files.forEach(function (setting) {
                    if (setting.key === searchKey) {
                        fileUrl = setting.fileUrl;
                    }
                });
            }
            return fileUrl;
        }

        /**
         * Edit the selected item
         */
        edit(): void {
            if (this.canEdit) {
                this.selectedSection.takeBackup();
                this.setMode(Meevo.Model.MaintenanceFormState.Editing);
                this.usageTrackingLog(Meevo.Model.VerbEnum.EditButtonClicked, null);
            }
        }

        /**
        * Saves the item currently being edited/added.
        */
        save(): angular.IPromise<any> {
            if (this.canSave) {
                this.loadingInProgress = true;
                this.selectedSection.preSave();
                this.usageTrackingLog(Meevo.Model.VerbEnum.SaveButtonClicked, null);
                const sectionEndPoint = this.selectedSection.baseEndpoint || this.baseEndpoint;
                return this.dataService.update(sectionEndPoint, this.selectedSection.model, this.selectedSection.sectionEndpoint)
                    .then((data: any) => {
                        this.selectedSection.model = data;
                        this.selectedSection.activate();
                        this.sectionSaved();
                        this.setMode(Meevo.Model.MaintenanceFormState.Readonly);
                        this.loggingService.trace(`Updates saved.`);
                    })
                    .finally(() => {
                        this.loadingInProgress = false;
                        this.postUpdate(this.selectedSection.model);
                    });
            }
            return null;
        }

        customSave(): angular.IPromise<any> {
            if (this.canSave) {
                this.loadingInProgress = true;
                this.selectedSection.preSave();
                this.usageTrackingLog(Meevo.Model.VerbEnum.SaveButtonClicked, null);
                return this.selectedSection.customSave()
                    .then(_ => {
                        this.selectedSection.activate();
                        this.setMode(Meevo.Model.MaintenanceFormState.Readonly);
                        this.loggingService.trace(`Updates saved.`);
                    })
                    .finally(() => {
                        this.loadingInProgress = false;
                        this.postUpdate(this.selectedSection.model);
                    });
            }
            return null;
        }

        /**
        * Hook to add processing after an update takes place.
        * @returns {}
        */
        postUpdate(model: any): void {
            if (Model.Guard.isSomething(this.closeCallback))
                this.closeCallback(model, true);
        }

        /**
         * Ends the edit/add session in progress.
         */
        cancel(): void {
            if (this.canCancel) {
                this.usageTrackingLog(Meevo.Model.VerbEnum.CancelButtonClicked, null);
                this.selectedSection.rollbackChanges();
                this.setMode(Meevo.Model.MaintenanceFormState.Readonly);
                this.postCancel();
            }
        }

        /**
        * Hook to add processing after a cancel takes place.
        * @returns {}
        */
        postCancel(): void {
            if (Model.Guard.isSomething(this.closeCallback))
                this.closeCallback(null, false);
        }

        /**
        * Deactivates the selected context.
        * Typically this is used to switch visual state from Detail to Search model via the controller.
        */
        deactivate(): void {
            alert("'deactivate' must be implemented on the controller containing the context.  Typically this is used to switch visual state from Detail to Search model");
        }

        /**
         * Determines whether the form is in a loading state.
         */
        get isLoading(): boolean {
            return this.loadingInProgress || (this.selectedSection && this.selectedSection.loadingInProgress);
        }

        /**
        * Determines and returns if the maintenance item is in an 'Editing' state.
        * @return {boolean}
        */
        get isEditing(): boolean {
            return this.mode === Meevo.Model.MaintenanceFormState.Editing;
        }

        /**
        * Determines and returns if the maintenance item is in an 'ReadOnly' state.
        * @return {boolean}
        */
        get isReadonly(): boolean {
            return this.mode === Meevo.Model.MaintenanceFormState.Readonly;
        }

        /**
        * Determines and returns if the maintenance item is in an 'Pending' state.
        * @return {boolean}
        */
        get isPending(): boolean {
            return this.mode === Meevo.Model.MaintenanceFormState.Pending;
        }

        /**
        * Determines and returns if the maintenance item is in an 'ReadOnly' state.
        * @return {boolean}
        */
        get isReadonlyToCommonLocation(): boolean {
            // Readonly when not in edit mode, not in CO mode or not a single location
            return this.mode === Meevo.Model.MaintenanceFormState.Readonly
                || (!this.isApplicationModeCO() && !this.isSingleLocation());
        }

        /**
        * Determines and returns if the maintenance form is in a state that will allow editing.
        * @return {boolean}
        */
        get canEdit(): boolean {
            return this.canEditLogic();
        }

        canEditLogic(): boolean {
            return this.selectedSection !== null &&
                !this.selectedSection.handlesOwnCrud &&
                this.isReadonly;
        }
        /**
        * Determines and returns if the maintenance form is in a state that will allow saving.
        * @return {boolean}
        */
        get canSave(): boolean {
            return this.canSaveLogic();
        }

        canSaveLogic(): boolean {
            return this.isEditing && this.selectedSection !== null && !this.selectedSection.handlesOwnCrud;
        }
        /**
        * Determines and returns if the maintenance form is in a state that will allow cancelling.
        * @return {boolean}
        */
        get canCancel(): boolean {
            return this.canCancelLogic();
        }

        canCancelLogic(): boolean {
            return this.isEditing && this.selectedSection !== null && !this.selectedSection.handlesOwnCrud;
        }

        /**
        * Determines whether or not the Maintenance Form should show the top level 'Edit' option.
        * @return {boolean}
        */
        get showEdit(): boolean {
            //if (!this.isApplicationModeCO() && (this.selectedSection.displayNameContentKey.indexOf("HOLIDAYS") !== -1)) {
            //    return false;
            //}
            return this.showEditLogic();
        }

        /**
         * Function which determins wether to show the 'Edit' option.
         * this was introduced to allow overriding the show edit logic.
         */
        showEditLogic(): boolean {
            if (this.selectedSection.displayNameContentKey === "SECTION_BUSINFO_NOTIFICATIONS") {
                return false;
            }

            return this.selectedSection !== null &&
                !this.selectedSection.handlesOwnCrud &&
                this.isReadonly;
        }

        /**
        * Determines whether or not the Maintenance Form should show the top level 'Cancel' option.
        * @return {boolean}
        */
        get showCancel(): boolean {
            return this.isEditing && this.selectedSection !== null && !this.selectedSection.handlesOwnCrud;
        }

        /**
        * Determines whether or not the Maintenance Form should show the top level 'Save' option.
        * @return {boolean}
        */
        get showSave(): boolean {
            return this.isEditing && this.selectedSection !== null && !this.selectedSection.handlesOwnCrud;
        }

        /**
        * Determines whether or not we can navigate away from the current section to another one.
        * @return {boolean}
        */
        get navigationBlocked(): boolean {
            return this.isEditing || (this.selectedSection && this.selectedSection.isEditing);
        }

        /**
        * Determines whether the application is a single location
        */
        public isSingleLocation(): boolean {
            return this.identityService.current().isSingleLocation;
        }


        /*
         *  Determine if location has single business type
        */ 
        get userHasSingleBusinessType(): Model.DataDetail {
            return this.identityService.userBusinessTypes.length === 1 ? this.identityService.userBusinessTypes[0] : null;
        }


        /**
        * Determines whether the application is in CO mode
        */
        public isApplicationModeCO(): boolean {
            return this.identityService.inCentralOfficeMode();
        }

        usageTrackingLog(verbEnum, payload): void {
            if (this.trackingService && this.selectedSection.noun && this.selectedSection.noun !== null && !this.preventUsageTracking) {
                var trackingItem = new Meevo.Model.TrackingItem(this.selectedSection.noun, verbEnum, payload, null);
                this.trackingService.saveTrackingInfo(trackingItem);
            }
        }

        /*
         * Uses the base key to builds security keys for the CRUD commands.
         * Edit and Delete keys are always generated.
         * Create and Copy keys can be centralized into the Edit key.
         * CO security keys are optional.
         */
        protected buildCrudSecurityKeysBase(baseKey, hasCreateKey = false, hasCopyKey = false) {
            this.editSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;
            this.deleteSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_DELETE;
            this.addSecurityKey = baseKey + ((hasCreateKey) ? Meevo.Components.Common.SecurityParts.KEY_PART_CREATE : Meevo.Components.Common.SecurityParts.KEY_PART_WRITE);
            this.copySecurityKey = baseKey + ((hasCopyKey) ? Meevo.Components.Common.SecurityParts.KEY_PART_COPY : Meevo.Components.Common.SecurityParts.KEY_PART_WRITE);
        }

        /**
        * Determines whether the user is in Single Location tenant or in CO mode
        */
        public isCoModeOrSingleLocation(): boolean {
            return this.isSingleLocation() || this.isApplicationModeCO();
        }


        sectionModelRetrieved(): void {}
        sectionModelRetrievalFailure(ex): void { }

        sectionSaved(): void {}
    }
}
